import localStorage from 'localstorage-ttl';
import { useObserver } from 'mobx-react';
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

import { useStores } from '../hooks/useStores';
import { UserRoles } from '../types/shared';
import config from '../utils/config';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        isAuthenticated: store.auth.isAuthenticated,
        userRole: store.auth.role,
    }));
}
interface PrivateRouteProps extends RouteProps {
    requiredRoles: UserRoles[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRoles, ...rest }) => {
    const { isAuthenticated, userRole } = useStoreData();
    const authHasRequiredRole = requiredRoles && requiredRoles.includes(userRole);
    console.log('isAuthenticated 2:', isAuthenticated);

    if (!isAuthenticated) {
        return (
            <Route
                {...rest}
                render={({ location }) => {
                    const pathToRedirect = requiredRoles && requiredRoles.includes(UserRoles.HOST) ? '/signin' : '/signin-party';
                    // const  = location.pathname === '/' ? '/signin' : '/signin-party';
                    // Storing the party link to redirect to it once user logs in
                    if (pathToRedirect === '/signin-party') {
                        localStorage.set(config.LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT, location.pathname);
                    }
                    return (
                        <Redirect
                            to={{
                                pathname: pathToRedirect,
                                state: { from: location },
                            }}
                        />
                    );
                }}
            />
        );
    }

    // TODO: Change the Loading placeholder for a proper loading page
    if (userRole === UserRoles.ANONYMOUS) {
        return <div>Loading...</div>;
    }

    if (!authHasRequiredRole) {
        return (
            <Route
                {...rest}
                render={({ location }) => {
                    const pathToRedirect =
                        userRole === UserRoles.HOST ? '/' : localStorage.get(config.LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT);
                    return (
                        <Redirect
                            to={{
                                pathname: pathToRedirect,
                                state: { from: location },
                            }}
                        />
                    );
                }}
            />
        );
    }

    return <Route {...rest} render={() => children} />;
};
export default PrivateRoute;
